import React, { useState } from 'react';

const LANGUAGES = [
  { code: 'en', flag: '🇺🇸', name: 'English' },
  { code: 'ur', flag: '🇵🇰', name: 'اردو' },
  { code: 'ar', flag: '🇸🇦', name: 'العربية' },
  { code: 'hi', flag: '🇮🇳', name: 'हिन्दी' },
  { code: 'bn', flag: '🇧🇩', name: 'বাংলা' },
  { code: 'es', flag: '🇪🇸', name: 'Español' },
  { code: 'fr', flag: '🇫🇷', name: 'Français' },
  { code: 'de', flag: '🇩🇪', name: 'Deutsch' },
  { code: 'zh', flag: '🇨🇳', name: '中文' },
  { code: 'ja', flag: '🇯🇵', name: '日本語' },
  { code: 'ko', flag: '🇰🇷', name: '한국어' },
  { code: 'tr', flag: '🇹🇷', name: 'Türkçe' },
  { code: 'ru', flag: '🇷🇺', name: 'Русский' },
  { code: 'pt', flag: '🇵🇹', name: 'Português' },
  { code: 'fa', flag: '🇮🇷', name: 'فارسی' },
];

const TRANSLATIONS = {
  en: {
    pageTitle: '🎬 Plans',
    heading: 'Upgrade Your Plan',
    subheading: 'Pay via JazzCash or EasyPaisa',
    currentPlan: 'Your Current Plan',
    currentBadge: 'Current',
    paymentInfo: '📌 Payment Info',
    paymentInfoText: 'After selecting a plan, you will receive the JazzCash/EasyPaisa number. Submit transaction ID after payment — admin will activate within 24 hours.',
    moviesPerDay: 'movies per day',
    shortsPerMovie: 'shorts per movie',
    quality1080: '1080p quality',
    quality4k: '4K quality',
    oneDevice: '1 device only',
    selectBtn: 'Get',
    currentPlanBtn: 'Current Plan',
    free: '🆓 Free',
  },
  ur: {
    pageTitle: '🎬 پلانز',
    heading: 'پلان اپ گریڈ کریں',
    subheading: 'جاز کیش یا ایزی پیسہ سے ادائیگی کریں',
    currentPlan: 'آپ کا موجودہ پلان',
    currentBadge: 'موجودہ',
    paymentInfo: '📌 ادائیگی کی معلومات',
    paymentInfoText: 'پلان منتخب کرنے کے بعد جاز کیش/ایزی پیسہ نمبر ملے گا۔ ادائیگی کے بعد ٹرانزیکشن آئی ڈی جمع کریں — ایڈمن 24 گھنٹے میں فعال کرے گا۔',
    moviesPerDay: 'فلمیں فی دن',
    shortsPerMovie: 'شارٹس فی فلم',
    quality1080: '1080p معیار',
    quality4k: '4K معیار',
    oneDevice: 'صرف 1 ڈیوائس',
    selectBtn: 'حاصل کریں',
    currentPlanBtn: 'موجودہ پلان',
    free: '🆓 مفت',
  },
  ar: {
    pageTitle: '🎬 الخطط',
    heading: 'ترقية خطتك',
    subheading: 'ادفع عبر JazzCash أو EasyPaisa',
    currentPlan: 'خطتك الحالية',
    currentBadge: 'الحالية',
    paymentInfo: '📌 معلومات الدفع',
    paymentInfoText: 'بعد اختيار الخطة، ستحصل على رقم JazzCash/EasyPaisa. أرسل معرف المعاملة بعد الدفع — سيقوم المشرف بالتفعيل خلال 24 ساعة.',
    moviesPerDay: 'أفلام في اليوم',
    shortsPerMovie: 'مقاطع لكل فيلم',
    quality1080: 'جودة 1080p',
    quality4k: 'جودة 4K',
    oneDevice: 'جهاز واحد فقط',
    selectBtn: 'احصل عليه',
    currentPlanBtn: 'الخطة الحالية',
    free: '🆓 مجاني',
  },
  hi: {
    pageTitle: '🎬 प्लान्स',
    heading: 'प्लान अपग्रेड करें',
    subheading: 'JazzCash या EasyPaisa से भुगतान करें',
    currentPlan: 'आपका वर्तमान प्लान',
    currentBadge: 'वर्तमान',
    paymentInfo: '📌 भुगतान जानकारी',
    paymentInfoText: 'प्लान चुनने के बाद JazzCash/EasyPaisa नंबर मिलेगा। भुगतान के बाद ट्रांजेक्शन ID सबमिट करें — एडमिन 24 घंटे में सक्रिय करेगा।',
    moviesPerDay: 'फिल्में प्रति दिन',
    shortsPerMovie: 'शॉर्ट्स प्रति फिल्म',
    quality1080: '1080p गुणवत्ता',
    quality4k: '4K गुणवत्ता',
    oneDevice: 'केवल 1 डिवाइस',
    selectBtn: 'प्राप्त करें',
    currentPlanBtn: 'वर्तमान प्लान',
    free: '🆓 मुफ़्त',
  },
  bn: {
    pageTitle: '🎬 প্ল্যান',
    heading: 'প্ল্যান আপগ্রেড করুন',
    subheading: 'JazzCash বা EasyPaisa দিয়ে পেমেন্ট করুন',
    currentPlan: 'আপনার বর্তমান প্ল্যান',
    currentBadge: 'বর্তমান',
    paymentInfo: '📌 পেমেন্ট তথ্য',
    paymentInfoText: 'প্ল্যান বাছাইয়ের পরে JazzCash/EasyPaisa নম্বর পাবেন। পেমেন্টের পরে ট্রানজেকশন আইডি জমা দিন — অ্যাডমিন ২৪ ঘণ্টার মধ্যে সক্রিয় করবেন।',
    moviesPerDay: 'মুভি প্রতিদিন',
    shortsPerMovie: 'শর্টস প্রতি মুভি',
    quality1080: '1080p মান',
    quality4k: '4K মান',
    oneDevice: 'শুধু ১টি ডিভাইস',
    selectBtn: 'নিন',
    currentPlanBtn: 'বর্তমান প্ল্যান',
    free: '🆓 বিনামূল্যে',
  },
  es: {
    pageTitle: '🎬 Planes',
    heading: 'Mejora tu Plan',
    subheading: 'Paga con JazzCash o EasyPaisa',
    currentPlan: 'Tu Plan Actual',
    currentBadge: 'Actual',
    paymentInfo: '📌 Info de Pago',
    paymentInfoText: 'Tras seleccionar un plan, recibirás el número de JazzCash/EasyPaisa. Envía el ID de transacción — el admin lo activará en 24 horas.',
    moviesPerDay: 'películas por día',
    shortsPerMovie: 'cortos por película',
    quality1080: 'calidad 1080p',
    quality4k: 'calidad 4K',
    oneDevice: 'solo 1 dispositivo',
    selectBtn: 'Obtener',
    currentPlanBtn: 'Plan Actual',
    free: '🆓 Gratis',
  },
  fr: {
    pageTitle: '🎬 Plans',
    heading: 'Améliorez votre Plan',
    subheading: 'Payez via JazzCash ou EasyPaisa',
    currentPlan: 'Votre Plan Actuel',
    currentBadge: 'Actuel',
    paymentInfo: '📌 Info de Paiement',
    paymentInfoText: "Après avoir sélectionné un plan, vous recevrez le numéro JazzCash/EasyPaisa. Soumettez l'ID de transaction — l'admin activera sous 24h.",
    moviesPerDay: 'films par jour',
    shortsPerMovie: 'courts par film',
    quality1080: 'qualité 1080p',
    quality4k: 'qualité 4K',
    oneDevice: '1 appareil seulement',
    selectBtn: 'Obtenir',
    currentPlanBtn: 'Plan Actuel',
    free: '🆓 Gratuit',
  },
  de: {
    pageTitle: '🎬 Pläne',
    heading: 'Plan upgraden',
    subheading: 'Zahlung via JazzCash oder EasyPaisa',
    currentPlan: 'Ihr aktueller Plan',
    currentBadge: 'Aktuell',
    paymentInfo: '📌 Zahlungsinfo',
    paymentInfoText: 'Nach der Planauswahl erhalten Sie die JazzCash/EasyPaisa-Nummer. Senden Sie die Transaktions-ID — der Admin aktiviert innerhalb von 24 Stunden.',
    moviesPerDay: 'Filme pro Tag',
    shortsPerMovie: 'Shorts pro Film',
    quality1080: '1080p Qualität',
    quality4k: '4K Qualität',
    oneDevice: 'nur 1 Gerät',
    selectBtn: 'Erhalten',
    currentPlanBtn: 'Aktueller Plan',
    free: '🆓 Kostenlos',
  },
  zh: {
    pageTitle: '🎬 套餐',
    heading: '升级套餐',
    subheading: '通过JazzCash或EasyPaisa付款',
    currentPlan: '您的当前套餐',
    currentBadge: '当前',
    paymentInfo: '📌 付款信息',
    paymentInfoText: '选择套餐后，您将收到JazzCash/EasyPaisa号码。付款后提交交易ID — 管理员将在24小时内激活。',
    moviesPerDay: '部电影/天',
    shortsPerMovie: '个短片/电影',
    quality1080: '1080p画质',
    quality4k: '4K画质',
    oneDevice: '仅限1台设备',
    selectBtn: '获取',
    currentPlanBtn: '当前套餐',
    free: '🆓 免费',
  },
  ja: {
    pageTitle: '🎬 プラン',
    heading: 'プランをアップグレード',
    subheading: 'JazzCashまたはEasyPaisaで支払い',
    currentPlan: '現在のプラン',
    currentBadge: '現在',
    paymentInfo: '📌 支払い情報',
    paymentInfoText: 'プラン選択後、JazzCash/EasyPaisaの番号が届きます。支払い後にトランザクションIDを送信 — 管理者が24時間以内に有効化します。',
    moviesPerDay: '映画/日',
    shortsPerMovie: 'ショート/映画',
    quality1080: '1080p画質',
    quality4k: '4K画質',
    oneDevice: '1台のみ',
    selectBtn: '取得する',
    currentPlanBtn: '現在のプラン',
    free: '🆓 無料',
  },
  ko: {
    pageTitle: '🎬 플랜',
    heading: '플랜 업그레이드',
    subheading: 'JazzCash 또는 EasyPaisa로 결제',
    currentPlan: '현재 플랜',
    currentBadge: '현재',
    paymentInfo: '📌 결제 정보',
    paymentInfoText: '플랜 선택 후 JazzCash/EasyPaisa 번호를 받게 됩니다. 결제 후 거래 ID를 제출하세요 — 관리자가 24시간 내에 활성화합니다.',
    moviesPerDay: '영화/일',
    shortsPerMovie: '쇼츠/영화',
    quality1080: '1080p 화질',
    quality4k: '4K 화질',
    oneDevice: '기기 1대만',
    selectBtn: '받기',
    currentPlanBtn: '현재 플랜',
    free: '🆓 무료',
  },
  tr: {
    pageTitle: '🎬 Planlar',
    heading: 'Planını Yükselt',
    subheading: 'JazzCash veya EasyPaisa ile öde',
    currentPlan: 'Mevcut Planın',
    currentBadge: 'Mevcut',
    paymentInfo: '📌 Ödeme Bilgisi',
    paymentInfoText: 'Plan seçtikten sonra JazzCash/EasyPaisa numarası alacaksınız. Ödeme sonrası işlem kimliğini gönderin — admin 24 saat içinde aktive eder.',
    moviesPerDay: 'film/gün',
    shortsPerMovie: 'short/film',
    quality1080: '1080p kalite',
    quality4k: '4K kalite',
    oneDevice: 'yalnızca 1 cihaz',
    selectBtn: 'Al',
    currentPlanBtn: 'Mevcut Plan',
    free: '🆓 Ücretsiz',
  },
  ru: {
    pageTitle: '🎬 Планы',
    heading: 'Улучшить план',
    subheading: 'Оплата через JazzCash или EasyPaisa',
    currentPlan: 'Ваш текущий план',
    currentBadge: 'Текущий',
    paymentInfo: '📌 Информация об оплате',
    paymentInfoText: 'После выбора плана вы получите номер JazzCash/EasyPaisa. Отправьте ID транзакции — администратор активирует в течение 24 часов.',
    moviesPerDay: 'фильмов/день',
    shortsPerMovie: 'роликов/фильм',
    quality1080: 'качество 1080p',
    quality4k: 'качество 4K',
    oneDevice: 'только 1 устройство',
    selectBtn: 'Получить',
    currentPlanBtn: 'Текущий план',
    free: '🆓 Бесплатно',
  },
  pt: {
    pageTitle: '🎬 Planos',
    heading: 'Melhore seu Plano',
    subheading: 'Pague via JazzCash ou EasyPaisa',
    currentPlan: 'Seu Plano Atual',
    currentBadge: 'Atual',
    paymentInfo: '📌 Info de Pagamento',
    paymentInfoText: 'Após selecionar o plano, receberá o número JazzCash/EasyPaisa. Envie o ID da transação — o admin ativará em 24 horas.',
    moviesPerDay: 'filmes/dia',
    shortsPerMovie: 'shorts/filme',
    quality1080: 'qualidade 1080p',
    quality4k: 'qualidade 4K',
    oneDevice: 'apenas 1 dispositivo',
    selectBtn: 'Obter',
    currentPlanBtn: 'Plano Atual',
    free: '🆓 Gratuito',
  },
  fa: {
    pageTitle: '🎬 طرح‌ها',
    heading: 'ارتقاء طرح',
    subheading: 'از طریق JazzCash یا EasyPaisa پرداخت کنید',
    currentPlan: 'طرح فعلی شما',
    currentBadge: 'فعلی',
    paymentInfo: '📌 اطلاعات پرداخت',
    paymentInfoText: 'پس از انتخاب طرح، شماره JazzCash/EasyPaisa دریافت خواهید کرد. پس از پرداخت شناسه تراکنش را ارسال کنید — مدیر ظرف ۲۴ ساعت فعال می‌کند.',
    moviesPerDay: 'فیلم در روز',
    shortsPerMovie: 'شورت در هر فیلم',
    quality1080: 'کیفیت 1080p',
    quality4k: 'کیفیت 4K',
    oneDevice: 'فقط ۱ دستگاه',
    selectBtn: 'دریافت',
    currentPlanBtn: 'طرح فعلی',
    free: '🆓 رایگان',
  },
};

function Plans({ user, onSelectPlan, onBack }) {
  const getSavedLang = () => {
    const saved = localStorage.getItem('cineshorts_lang');
    if (saved) {
      const found = LANGUAGES.find(l => l.code === saved);
      if (found) return found;
    }
    return LANGUAGES[0];
  };

  const [selectedLang] = useState(getSavedLang);
  const t = TRANSLATIONS[selectedLang.code] || TRANSLATIONS['en'];
  const isRTL = ['ar', 'ur', 'fa'].includes(selectedLang.code);

  const getPlans = (t) => [
    {
      id: 'pro_basic',
      name: '⭐ Pro Basic',
      price: 'PKR 2,000/month',
      features: [
        `3 ${t.moviesPerDay}`,
        `5 ${t.shortsPerMovie}`,
        t.quality1080,
        t.oneDevice,
      ]
    },
    {
      id: 'pro_premium',
      name: '👑 Pro Premium',
      price: 'PKR 4,500/month',
      features: [
        `10 ${t.moviesPerDay}`,
        `8 ${t.shortsPerMovie}`,
        t.quality4k,
        t.oneDevice,
      ]
    }
  ];

  const plans = getPlans(t);

  const cardStyle = {
    background: '#1a1a1a',
    border: '1px solid rgba(245,158,11,0.2)',
    borderRadius: '16px',
    padding: '24px',
    marginBottom: '16px',
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0f0f0f', color: '#fff', direction: isRTL ? 'rtl' : 'ltr' }}>

      {/* Header */}
      <div style={{
        background: '#111', borderBottom: '1px solid #2a2a2a',
        padding: '16px 24px', display: 'flex', alignItems: 'center', gap: '16px'
      }}>
        <button onClick={onBack} style={{
          background: 'none', border: 'none',
          color: '#f59e0b', fontSize: '20px', cursor: 'pointer'
        }}>←</button>
        <h1 style={{
          fontSize: '20px', fontWeight: '800',
          background: 'linear-gradient(90deg, #f59e0b, #fbbf24)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'
        }}>{t.pageTitle}</h1>
      </div>

      <div style={{ maxWidth: '600px', margin: '0 auto', padding: '32px 16px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: '800', textAlign: 'center', marginBottom: '8px' }}>
          {t.heading}
        </h2>
        <p style={{ color: '#9ca3af', textAlign: 'center', marginBottom: '24px' }}>
          {t.subheading}
        </p>

        {/* Current Plan */}
        <div style={{
          background: '#1a1a1a', border: '1px solid #2a2a2a',
          borderRadius: '16px', padding: '16px',
          textAlign: 'center', marginBottom: '24px'
        }}>
          <p style={{ color: '#9ca3af', fontSize: '13px' }}>{t.currentPlan}</p>
          <p style={{
            fontSize: '20px', fontWeight: '800', marginTop: '4px',
            background: 'linear-gradient(90deg, #f59e0b, #fbbf24)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'
          }}>
            {user?.plan === 'free' ? t.free : user?.plan}
          </p>
        </div>

        {/* Plan Cards */}
        {plans.map((plan) => (
          <div key={plan.id} style={cardStyle}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
              <div>
                <h3 style={{ fontSize: '20px', fontWeight: '700' }}>{plan.name}</h3>
                <p style={{
                  fontSize: '24px', fontWeight: '800', marginTop: '4px',
                  background: 'linear-gradient(90deg, #f59e0b, #fbbf24)',
                  WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'
                }}>{plan.price}</p>
              </div>
              {user?.plan === plan.id && (
                <span style={{
                  background: 'rgba(245,158,11,0.2)', color: '#f59e0b',
                  fontSize: '12px', fontWeight: '700',
                  padding: '4px 12px', borderRadius: '20px'
                }}>{t.currentBadge}</span>
              )}
            </div>

            <ul style={{ marginBottom: '20px' }}>
              {plan.features.map((f, i) => (
                <li key={i} style={{
                  display: 'flex', alignItems: 'center', gap: '8px',
                  color: '#d1d5db', marginBottom: '8px', fontSize: '14px'
                }}>
                  <span style={{ color: '#f59e0b' }}>✓</span> {f}
                </li>
              ))}
            </ul>

            <button
              onClick={() => onSelectPlan(plan)}
              disabled={user?.plan === plan.id}
              style={{
                width: '100%', padding: '14px',
                background: user?.plan === plan.id ? '#2a2a2a' : 'linear-gradient(90deg, #f59e0b, #d97706)',
                border: 'none', borderRadius: '12px',
                color: user?.plan === plan.id ? '#6b7280' : '#000',
                fontWeight: '800', fontSize: '15px',
                cursor: user?.plan === plan.id ? 'not-allowed' : 'pointer'
              }}
            >
              {user?.plan === plan.id ? t.currentPlanBtn : `${plan.name} ${t.selectBtn}`}
            </button>
          </div>
        ))}

        {/* Info Box */}
        <div style={{
          background: 'rgba(245,158,11,0.05)',
          border: '1px solid rgba(245,158,11,0.2)',
          borderRadius: '16px', padding: '20px', marginTop: '8px'
        }}>
          <h4 style={{ color: '#f59e0b', fontWeight: '700', marginBottom: '8px' }}>{t.paymentInfo}</h4>
          <p style={{ color: '#9ca3af', fontSize: '14px', lineHeight: '1.6' }}>{t.paymentInfoText}</p>
        </div>
      </div>
    </div>
  );
}

export default Plans;
